import L6ToL5Processor from "./L6ToL5Processor"

abstract class L6ToL5TagProcessor {
	rootProc: L6ToL5Processor

	constructor(rootProc: L6ToL5Processor) {
		this.rootProc = rootProc
	}
}

export default L6ToL5TagProcessor
